import styled from 'styled-components'

export const AppContainer = styled.div`
    width: 100%;
    padding: ${props => `${props.theme.paddingXXS}px 0 ${props.theme.paddingSM}px 0`};
    flex: 1;
    text-align: center;
    overflow-y: auto;
`
